module.exports = "<ol class=\"breadcrumb\">\n    <li v-for=\"item in list\" v-bind:class=\"{ active: item.active }\">\n        <a href=\"#\" v-on:click.stop.prevent=\"changeLocation($router, item.link)\" v-if=\"item.active\">{{item.text}}</a>\n        <span v-if=\"!item.active\">{{item.text}}</span>\n    </li>\n</ol>";


//////////////////
// WEBPACK FOOTER
// ./src/components/breadcrumb/breadcrumb.html
// module id = 6
// module chunks = 0